import type {MediaItemData} from '@Components/simple-media-carousel/simple-media-carousel.types';
import type {GraphicsMetaMapType} from '@Components/social-media/publish-params.types';
import type {OrderedMediaItem} from './social-post-content-media-wrapper.types';
import {FIRST_ASSET_ELEMENT_NUMBER, PREVIEW_ASSET_ELEMENT_ID_PREFIX} from './social-post-content-media-wrapper.types';

export const chunkIntoRows = <ItemType>(items: ItemType[], itemsPerRow: number): ItemType[][] => {
  const rows: ItemType[][] = [];

  for (let rowStartIndex = 0; rowStartIndex < items.length; rowStartIndex += itemsPerRow) {
    rows.push(items.slice(rowStartIndex, rowStartIndex + itemsPerRow));
  }

  return rows;
};

export const getAssetIndexes = (assetCount: number): number[] => {
  return Array.from({length: assetCount}, (_unusedValue, assetIndex) => assetIndex);
};

export const getPreviewAssetElementId = (assetIndex: number): string => {
  return `${PREVIEW_ASSET_ELEMENT_ID_PREFIX}${assetIndex + FIRST_ASSET_ELEMENT_NUMBER}`;
};

export const getOrderedCarouselMediaItems = (designsGraphicsMetaMap: GraphicsMetaMapType): MediaItemData[] => {
  const orderedMediaItems: OrderedMediaItem[] = Object.keys(designsGraphicsMetaMap).flatMap((posterHashedId) => {
    return Object.keys(designsGraphicsMetaMap[posterHashedId]).map((pageHashedId) => {
      const graphicMeta = designsGraphicsMetaMap[posterHashedId][pageHashedId];

      return {
        mediaUrl: graphicMeta.graphicURL,
        isVideo: graphicMeta.isVideo,
        externalMediaDesign: {posterHashedId: posterHashedId, pageHashedId: pageHashedId},
        order: graphicMeta.order,
      };
    });
  });

  orderedMediaItems.sort((firstMediaItem, secondMediaItem) => firstMediaItem.order - secondMediaItem.order);

  return orderedMediaItems.map((orderedMediaItem) => {
    return {
      mediaUrl: orderedMediaItem.mediaUrl,
      isVideo: orderedMediaItem.isVideo,
      externalMediaDesign: orderedMediaItem.externalMediaDesign,
    };
  });
};
